export default "__VITE_ASSET__bjwkkpNs__"